var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"pageTitle":_vm.$route.params.title}},[(_vm.$route.params.canDownLoad)?_c('div',{attrs:{"slot":"right"},on:{"click":_vm.toDownLoad},slot:"right"},[_vm._v(" 下载 ")]):_vm._e()]),_c('div',{attrs:{"id":"reeading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }